import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {RQ_GET_DML_DOCUMENT_STATUS_API} from '@app/reactQuery/apis/constants';

export const RQUseGetDMLDocumentStatusData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_dml_document_status_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_DML_DOCUMENT_STATUS_API,
        null,
        certificate,
        {divisionId: divisionId},
        signal,
      );
    },
    ...options,
  });
};
